// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-form__title {
  font-size: var(--quiz-form-title-font-size);
  font-family: var(--quiz-form-title-font-family);
  color: var(--quiz-form-title-color);
}
.quiz-form__section {
  margin-bottom: 0.5rem;
  font-family: var(--quiz-form-section-font-family);
  color: var(--quiz-form-section-color);
}
.quiz-form__second-title {
  font-size: var(--quiz-form-second-title-font-size);
  font-family: var(--quiz-form-second-font-family);
  color: var(--quiz-form-second-title-color);
}
.quiz-form__submit-button {
  margin-top: 15px;
}
.quiz-form__collapse .ant-collapse-header {
  border-radius: unset;
  font-size: 1rem;
  font-weight: bold;
  padding-right: 2rem;
}
.quiz-form__collapse .ant-collapse-header .ant-collapse-header-text {
  color: var(--default-grey-700);
  font-size: var(--default-size-body);
  font-weight: bold;
  padding-right: 2rem;
}
.quiz-form__collapse .ant-collapse-item {
  padding: 0 1rem;
  border: 1px solid var(--default-grey-700);
  border-radius: 4px;
  margin-bottom: 0.5rem;
}
.quiz-form__collapse .ant-collapse-item-active {
  border: 1px solid var(--default-blue-500);
}
.quiz-form__collapse .ant-collapse-item-active .ant-collapse-expand-icon {
  color: var(--default-blue-500);
}
.quiz-form__collapse .ant-collapse-item-active .ant-collapse-header-text {
  color: var(--default-blue-500);
}
.quiz-form__collapse-panel {
  border-radius: 4px !important;
}
.quiz-form__collapse-panel .single-radio {
  display: flex;
  gap: 10px;
}
.quiz-form .checkbox-button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.quiz-form .checkbox-button.ant-radio-wrapper,
.quiz-form .checkbox-button.ant-checkbox-wrapper {
  display: inline-flex;
  align-items: center;
  margin-inline-start: 0;
  margin-inline-end: 8px;
}
.quiz-form .checkbox-button.ant-radio-wrapper .ant-radio,
.quiz-form .checkbox-button.ant-radio-wrapper .ant-checkbox,
.quiz-form .checkbox-button.ant-checkbox-wrapper .ant-radio,
.quiz-form .checkbox-button.ant-checkbox-wrapper .ant-checkbox {
  display: none;
}
.quiz-form .checkbox-button.ant-radio-wrapper span:last-child,
.quiz-form .checkbox-button.ant-checkbox-wrapper span:last-child {
  display: inline-flex;
  align-items: center;
  padding: 6px 18px;
  border: 1.5px solid #d9d9d9;
  border-radius: 20px;
  background: #fff;
  cursor: pointer;
  font-size: 0.9rem;
  line-height: 1.4;
  transition: border-color 0.2s, background 0.2s, color 0.2s;
  user-select: none;
}
.quiz-form .checkbox-button.ant-radio-wrapper span:last-child:hover,
.quiz-form .checkbox-button.ant-checkbox-wrapper span:last-child:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}
.quiz-form .checkbox-button.ant-radio-wrapper.ant-radio-wrapper-checked span:last-child, .quiz-form .checkbox-button.ant-radio-wrapper.ant-checkbox-wrapper-checked span:last-child,
.quiz-form .checkbox-button.ant-checkbox-wrapper.ant-radio-wrapper-checked span:last-child,
.quiz-form .checkbox-button.ant-checkbox-wrapper.ant-checkbox-wrapper-checked span:last-child {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}
.quiz-form .checkbox-button.ant-radio-wrapper.ant-radio-wrapper-disabled span:last-child, .quiz-form .checkbox-button.ant-radio-wrapper.ant-checkbox-wrapper-disabled span:last-child,
.quiz-form .checkbox-button.ant-checkbox-wrapper.ant-radio-wrapper-disabled span:last-child,
.quiz-form .checkbox-button.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled span:last-child {
  opacity: 0.5;
  cursor: not-allowed;
}
.quiz-form .ant-form-item-extra {
  margin-top: 1rem;
}
.quiz-form .ant-space-item {
  margin: 15px 0;
}
.quiz-form__inputs {
  font-family: var(--quiz-form-inputs-font-family);
}
.quiz-form__wrapper-submit {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}
.quiz-form__wrapper-text-output {
  text-align: center;
  padding: 3.125rem;
}
.quiz-form .wrapper-passed-fail-quiz {
  text-align: justify;
  color: var(--default-grey-700);
  font-size: var(--default-size-body);
}`, "",{"version":3,"sources":["webpack://./src/components/ui/QuizForm/QuizForm.scss"],"names":[],"mappings":"AACI;EACI,2CAAA;EACA,+CAAA;EACA,mCAAA;AAAR;AAGI;EACI,qBAAA;EACA,iDAAA;EACA,qCAAA;AADR;AAII;EACI,kDAAA;EACA,gDAAA;EACA,0CAAA;AAFR;AAKI;EACI,gBAAA;AAHR;AAOQ;EACI,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AALZ;AAOY;EACI,8BAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;AALhB;AASQ;EACI,eAAA;EACA,yCAAA;EACA,kBAAA;EACA,qBAAA;AAPZ;AAUQ;EACI,yCAAA;AARZ;AASY;EACI,8BAAA;AAPhB;AASY;EACI,8BAAA;AAPhB;AAWQ;EACI,6BAAA;AATZ;AAYY;EACI,aAAA;EACA,SAAA;AAVhB;AAeI;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAbR;AAgBI;;EAEI,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AAdR;AAgBQ;;;;EAEI,aAAA;AAZZ;AAeQ;;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0DAAA;EACA,iBAAA;AAZZ;AAcY;;EACI,kCAAA;EACA,2BAAA;AAXhB;AAeQ;;;EAEI,gCAAA;EACA,kCAAA;EACA,WAAA;AAZZ;AAeQ;;;EAEI,YAAA;EACA,mBAAA;AAZZ;AAgBI;EACI,gBAAA;AAdR;AAiBI;EACI,cAAA;AAfR;AAkBI;EACI,gDAAA;AAhBR;AAmBI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AAjBR;AAoBI;EACI,kBAAA;EACA,iBAAA;AAlBR;AAqBI;EACI,mBAAA;EACA,8BAAA;EACA,mCAAA;AAnBR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
